import { render, staticRenderFns } from "./ranking-element-aside.component.vue?vue&type=template&id=33808ff3&scoped=true"
import script from "./ranking-element-aside.component.vue?vue&type=script&lang=ts"
export * from "./ranking-element-aside.component.vue?vue&type=script&lang=ts"
import style0 from "./ranking-element-aside.component.vue?vue&type=style&index=0&id=33808ff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33808ff3",
  null
  
)

export default component.exports